import { FullEvent } from 'model';

export type EventDateBadgeOutput =
	| {
			dayOfWeek: string;
			day: number;
			month: string;
			newMonth: string | null;
			previousMonths: string[];
	  }
	| false;

export const eventCalendarDateBadge = (events: FullEvent[]): EventDateBadgeOutput[] => {
	const processedEvents: EventDateBadgeOutput[] = [];
	const seenDays = new Set<string>();
	const seenMonths = new Set<string>();
	let previousEventDate: Date | undefined;

	if (events) {
		for (const event of events) {
			const monthsWithoutEvents: string[] = [];
			const eventDate = new Date(event.eventDate);
			const day = eventDate.getDate();
			const month = eventDate.toLocaleString('en-US', { month: 'long' });
			const year = eventDate.getFullYear();
			const dayOfWeek = eventDate.toLocaleString('en-US', { weekday: 'long' }).slice(0, 3);
			const uniqueDayIdentifier = `${year}-${month}-${day}`;
			const uniqueMonthIdentifier = `${year}-${month}`;

			// This is the DateBadge object
			const newDateBadge: EventDateBadgeOutput = {
				dayOfWeek,
				day,
				month: month.slice(0, 3),
				newMonth: null,
				previousMonths: []
			};

			// This checks to see if previous months have events to display blank month
			if (previousEventDate) {
				const yearDiff = eventDate.getFullYear() - previousEventDate.getFullYear();
				const monthDiff = eventDate.getMonth() - previousEventDate.getMonth();
				const totalMonthDiff = yearDiff * 12 + monthDiff;

				if (totalMonthDiff > 1) {
					for (let i = 1; i < totalMonthDiff; i++) {
						const missingMonthDate = new Date(previousEventDate);
						missingMonthDate.setMonth(previousEventDate.getMonth() + i);
						const missingMonthName = missingMonthDate.toLocaleString('en-US', { month: 'long' });
						monthsWithoutEvents.push(missingMonthName);
					}
				}
			}
			previousEventDate = eventDate;

			// This detects when we come up to a new month so we can add divider
			if (!seenMonths.has(uniqueMonthIdentifier)) {
				seenMonths.add(uniqueMonthIdentifier);
				newDateBadge.newMonth = month;
				newDateBadge.previousMonths = monthsWithoutEvents;
			}

			// This detects when we get to a new day so we can add the dateBadge
			if (!seenDays.has(uniqueDayIdentifier)) {
				seenDays.add(uniqueDayIdentifier);
				processedEvents.push(newDateBadge);
			} else {
				processedEvents.push(false);
			}
		}
	}

	return processedEvents;
};
